export default "__VITE_ASSET__DSXyAPLM__"